import { useMemo } from "react";

import { type ApiServiceWaiterDescriptor, CloudflowEngine, CloudFlowProvider } from "@doitintl/cmp-models";
import { getCollection } from "@doitintl/models-any";
import { useCollectionData } from "@doitintl/models-hooks";

export type WaiterAutocompleteValue = ApiServiceWaiterDescriptor & { id: string };

export const useAWSWaiters = (service: string, version: string) => {
  const waitersQuery = useMemo(
    () =>
      getCollection(CloudflowEngine)
        .doc("integrations")
        .collection("apis")
        .doc(CloudFlowProvider.AWS)
        .collection("services")
        .doc(service)
        .collection("versions")
        .doc(version)
        .collection("waiters"),
    [service, version]
  );

  const [waiters, waitersLoading, waitersError] = useCollectionData(waitersQuery, {
    caching: true,
    cachingKeys: ["cloudflow-waiters", service, version],
    idField: "id",
  });

  return { waiters, waitersLoading, waitersError };
};
